<div class="container-type">
    <div class="search-wrapper">
        <div class="tv-round-input-extensible-no-label full-width">
            <mat-form-field>
                <mat-label>Chercher</mat-label>
                <mat-icon matPrefix>search</mat-icon>
                <input matInput [formControl]="searchControl" />
                <button
                    *ngIf="searchControl.value"
                    matSuffix
                    aria-label="Clear"
                    class="tv-clear-input-icon-button"
                    (click)="clearSearchInput()">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
        </div>
    </div>
    <div class="container-route-name" *ngIf="goBack">
        <mat-icon (click)="goBackParent()" matPrefix class="icon-back">arrow_circle_left</mat-icon>
        <span class="route-name">{{ this.routeName }}</span>
    </div>

    <div class="full-width list-container-wrapper">
        <div class="list-container">
            <mat-list>
                <mat-list-item *ngFor="let type of this.typeSelectedDisplayList">
                    <div class="type-line full-width">
                        <button class="select-action" (click)="selectType(type, index)">
                            <mat-icon *ngIf="!type?.isSelected" matPrefix class="small-icon-add">add_circle</mat-icon>
                            <mat-icon *ngIf="type?.isSelected" matPrefix class="small-icon-check">check_circle</mat-icon>
                        </button>
                        <p class="type-name">{{ type?.libevt }}</p>
                        <mat-icon *ngIf="type?.children?.length > 0" (click)="showChildren(type)" matSuffix class="small-icon-arrow"
                            >arrow_right</mat-icon
                        >
                    </div>
                </mat-list-item>
            </mat-list>
        </div>
        <div class="screen-action-container">
            <button class="tv-ns-validation-large-button" (click)="submit()">Valider</button>
        </div>
    </div>
</div>
